import { render } from "./successLogin.vue?vue&type=template&id=54f8a781"
import script from "./successLogin.vue?vue&type=script&lang=js"
export * from "./successLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__